const formatDateToDisplay = (date) => {
    return date.toLocaleDateString("en-US", { month: 'long' })
        + " " + date.toLocaleDateString("en-US", { day: 'numeric' })
        + ", " + date.toLocaleDateString("en-US", { year: 'numeric' })
}

export default formatDateToDisplay